const PANXER_PROD_ID = 8645531402408        //战车产品ID
const AISTATION_PROD_ID = 9209012977832      //底座产品ID
const AISTATION_BLUE_SUK_ID = 54644923891880  //底座蓝色skuId

const PANXER_SINGLE_SKU_ID = 49841529553064 //战车单台skuId
const PANXER_DOUBLE_SKU_ID = 49969983750312 //战车双台skuId
const EILIK_PROD_ID = 42907716386984  //EILIK产品ID,蓝色
var buyEilikNum = 0 //购买eilik的数量
function updatebundleprice(){
    var totalprice = 0;
    var totalcomapreprice = 0;
    window.bundle_items = [];
    document.querySelectorAll(".bundle-option.active").forEach(function(option){
        var price = parseInt(option.getAttribute("data-price"));
        var comapreprice = parseInt(option.getAttribute("data-comapre-price"));
        var id = parseInt(option.querySelector("#masterselect").value);
        var quantity = parseInt(option.querySelector(".product-bundle-qty input").value)
        !isNaN(price) ? totalprice = totalprice + price*quantity : "";
        !isNaN(comapreprice) ? totalcomapreprice = totalcomapreprice + comapreprice*quantity : "";
        !isNaN(id) ? window.bundle_items.push({
            id: id,
            quantity: quantity
        }) : "";
    });

    document.querySelector(".bundle-price > span:first-of-type").innerHTML = theme.Currency.formatMoney(
        totalprice,
        theme.moneyFormat
    ).replace(' USD', '').replace('$', 'US $');


    if(totalcomapreprice ===0){
        let dom = document.querySelector(".bundle-price > span:last-of-type")
        $(dom).hide()
    }else {
        let dom = document.querySelector(".bundle-price > span:last-of-type")
        $(dom).show()
        dom.innerHTML = theme.Currency.formatMoney(
            totalcomapreprice,
            theme.moneyFormat
        ).replace(' USD', '').replace('$', 'US $');
    }
}

function updatefrequentboughtprice(){
    var totalprice = 0;
    var totalcomapreprice = 0;
    window.frequent_items = [];
    document.querySelectorAll(".frequenty-product.active").forEach(function(option){
        var price = parseInt(option.getAttribute("data-price"));
        var comapreprice = parseInt(option.getAttribute("data-comapre-price"));
        var id = parseInt(option.querySelector("#masterselect").value);
        // var quantity = parseInt(option.querySelector(".product-bundle-qty input").value)
        var quantity = 1;
        !isNaN(price) ? totalprice = totalprice + price*quantity : "";
        !isNaN(comapreprice) ? totalcomapreprice = totalcomapreprice + comapreprice*quantity : "";
        !isNaN(id) ? window.frequent_items.push({
            id: id,
            quantity: quantity
        }) : "";
    });

    document.querySelector(".frequent_total_price").innerHTML = theme.Currency.formatMoney(
        totalprice,
        theme.moneyFormat
    ).replace(' USD', '').replace('$', 'US $');

    document.querySelector(".frequent_total_compare").innerHTML = theme.Currency.formatMoney(
        totalcomapreprice,
        theme.moneyFormat
    ).replace(' USD', '').replace('$', 'US $');
}

document.querySelectorAll(".frequenty-product").forEach(function(product){
    product.addEventListener("click", function(){
        if (this.classList.contains("empty-product")) {
            return
        }
        this.classList.toggle("active");
        updatefrequentboughtprice()
    });
});

document.querySelectorAll(".bundle-option").forEach(function(product){
    product.addEventListener("click", function(e){
        if (this.querySelector('.product-bundle-options').contains(e.target) || this.querySelector('.product-bundle-qty').contains(e.target)){
            this.classList.add("active");
        } else{
            this.classList.toggle("active");
        }
        let bundle_list = document.querySelectorAll(".main-product");
        bundle_list.forEach((bun) => {
            if (product === bun) {
                console.log("self");
            } else {
                if (product.classList.contains('main-product')) {
                    bun.classList.remove("active");
                }
            }
        })

        const swiperIndex = this.getAttribute("data-index");
        if (swiperIndex !== null) {
            swiper2.slideTo(swiperIndex, 1000, false);
        }
        updatebundleprice()
    });
});

document.querySelectorAll(".product-bundle-qty").forEach(function(btn){
    btn.querySelector(".qty-plus").addEventListener("click", function(){
        var qty = parseInt(btn.querySelector("input").value);
        qty++;
        btn.querySelector("input").value = qty;
        updatebundleprice();
    });

    btn.querySelector(".qty-minus").addEventListener("click", function(){
        var qty = parseInt(btn.querySelector("input").value);
        qty--;

        if (qty > 0) {
            btn.querySelector("input").value = qty;
            updatebundleprice();
        }
    });

    btn.querySelector("input").addEventListener("change", function(){
        updatebundleprice();
    })
});

document.querySelectorAll(".product-bundle-option").forEach(function(option){
    option.addEventListener("click", function(){
        this.parentElement.querySelector(".active").classList.remove("active");
        this.classList.add("active");
        var price = this.getAttribute("data-price");
        var comapreprice = this.getAttribute("data-comapre-price");
        var pricemain = this.getAttribute("data-price-main");
        var comaprepricemain = this.getAttribute("data-comapre-price-main");
        var image = this.getAttribute("data-image");
        var id = this.getAttribute("data-id");
        this.parentElement.parentElement.previousElementSibling.querySelector("img").setAttribute("src", image);
        this.parentElement.previousElementSibling.previousElementSibling.querySelector("span.price-text").innerHTML = theme.Currency.formatMoney(price, theme.moneyFormat).replace(' USD', '');
        let compareEl = this.parentElement.previousElementSibling.previousElementSibling.querySelector("span.compare-price-text");
        if (compareEl !== null) {
            compareEl.innerHTML = theme.Currency.formatMoney(comapreprice, theme.moneyFormat).replace(' USD', '');
        }
        this.parentElement.parentElement.parentElement.setAttribute("data-price", pricemain);
        this.parentElement.parentElement.parentElement.setAttribute("data-comapre-price", comaprepricemain);
        this.parentElement.previousElementSibling.value = id;
        this.parentElement.parentElement.querySelector("p.product-title").textContent = this.getAttribute("title");
        const swiperIndex = this.getAttribute("data-index");
        if (swiperIndex !== null) {
            swiper2.slideTo(swiperIndex, 1000, false);
        }
        updatebundleprice();
    })
});
/**
 * @return number 台数
 */
function getChoosePanxerNum (){
    let bugNum= 0
    for(let item of window.bundle_items){
        if(item.id === PANXER_SINGLE_SKU_ID){
            // bugNum  = item.
        }
        if(item.id === PANXER_DOUBLE_SKU_ID){

        }
    }
    return bugNum
}

function checkChoosePanxer (){
    let isChoosePanxer = false
    for(let item of window.bundle_items){
        if(item.id === PANXER_SINGLE_SKU_ID||item.id === PANXER_DOUBLE_SKU_ID){
            isChoosePanxer = true
            break
        }
    }
    return isChoosePanxer
}
function checkChooseAistation(){
    let isChooseAistation = false
    for(let item of window.bundle_items){
        if(item.id === AISTATION_BLUE_SUK_ID){
            isChooseAistation = true
            break
        }
    }
    return isChooseAistation
}
document.querySelector(".addbundleproductstocart") != null
    ?   document.querySelector(".addbundleproductstocart").addEventListener("click", function(){
        if (window.bundle_items != undefined && window.bundle_items != "") {
            //判断当前产品是否为panxer，若为panxer则需要进行加购eilik判断
            if(window.productData&&((window.productData.id === PANXER_PROD_ID && checkChoosePanxer())||(window.productData.id === AISTATION_PROD_ID && checkChooseAistation()))){

                //显示弹框进行加购,判断勾选的是单台战车还是双台战车
                let tipsDom = document.querySelector("#addEilikDialog")
                tipsDom.style.display = "flex"
                document.querySelector("#buyNum")&&(document.querySelector("#buyNum").value = 1)

            }else {
                jQuery.post('/cart/add.js', {
                    items: window.bundle_items
                }).done(function(item){
                    let items_obj = JSON.parse(item);
                    items_obj["items"].forEach(i => {
                        window.customCart.update(i);
                    })
                });
            }
        }
        else
        {
            alert("No option is choose");
        }
    })
    : "";


document.querySelector(".addfreuentproductstocart") != null
    ?   document.querySelector(".addfreuentproductstocart").addEventListener("click", function(){
        if (window.frequent_items != undefined && window.frequent_items != "") {
            jQuery.post('/cart/add.js', {
                items: window.frequent_items
            }).done(function(item){
                let items_obj = JSON.parse(item);
                items_obj["items"].forEach(i => {
                    window.customCart.update(i);
                })
            });
        }
        else
        {
            alert("No option is choose");
        }
    })
    : "";

/**
 * 追加eilik产品
 * @param operate 操作 minu(增加) add(减少)
 */
function updateProductNum(operate){
    let numberDom = document.querySelector("#buyNum")
    let num = parseInt(numberDom.value)
    if(operate === 'minu'){
        if(num<=1){
            return
        }
        num-=1
    }

    if(operate === 'add'){
        num+=1
    }
    numberDom.value = num
}
/**
 * 追加eilik产品
 * @param state 操作 cancel(拥有，不加购) add(没拥有，加购) confirm(升级确定，加入购物车)
 */
function addEilik(state){
    if(state === 'add'){
        let numberDom = document.querySelector("#buyNum")
        let num = parseInt(numberDom.value)
        if(num<=0){
            return
        }
        buyEilikNum = num
        //隐藏加购弹框，展示版本升级提示
        document.querySelector("#addEilikDialog")&&
        (document.querySelector("#addEilikDialog").style.display = "none")
        //展示版本升级提示
        document.querySelector("#updateDialog")&&
        (document.querySelector("#updateDialog").style.display = "flex")

    }
    else if(state === 'aistation_add'){
        let numberDom = document.querySelector("#buyNum")
        let num = parseInt(numberDom.value)
        if(num<=0){
            return
        }
        buyEilikNum = num
        //隐藏加购弹框，展示版本升级提示
        document.querySelector("#addEilikDialog")&&
        (document.querySelector("#addEilikDialog").style.display = "none")
        let prodItems =  JSON.parse(JSON.stringify(window.bundle_items))
        if(buyEilikNum>0){
            prodItems.push(
                {
                    id:EILIK_PROD_ID, //蓝色eilik
                    quantity:buyEilikNum
                }
            )
        }
        document.querySelector("#updateDialog")&&
        (document.querySelector("#updateDialog").style.display = "none")
        jQuery.post('/cart/add.js', {
            items: prodItems
        }).done(function(item){
            let items_obj = JSON.parse(item);
            items_obj["items"].forEach(i => {
                window.customCart.update(i);
            })
        });

    }
    else if(state === 'cancel'){
        buyEilikNum = 0
        //隐藏加购弹框，展示版本升级提示
        document.querySelector("#addEilikDialog")&&
        (document.querySelector("#addEilikDialog").style.display = "none")
        //展示版本升级提示
        document.querySelector("#updateDialog")&&
        (document.querySelector("#updateDialog").style.display = "flex")
    }else if(state === 'aistation_cancel'){
        buyEilikNum = 0
        //隐藏加购弹框，展示版本升级提示
        document.querySelector("#addEilikDialog")&&
        (document.querySelector("#addEilikDialog").style.display = "none")
        jQuery.post('/cart/add.js', {
            items: window.bundle_items
        }).done(function(item){
            let items_obj = JSON.parse(item);
            items_obj["items"].forEach(i => {
                window.customCart.update(i);
            })
        });
    }
    else {
        let prodItems =  JSON.parse(JSON.stringify(window.bundle_items))
        if(buyEilikNum>0){
            prodItems.push(
                {
                        id:EILIK_PROD_ID, //蓝色eilik
                        quantity:buyEilikNum
                }
            )
        }
        document.querySelector("#updateDialog")&&
        (document.querySelector("#updateDialog").style.display = "none")
        jQuery.post('/cart/add.js', {
            items: prodItems
        }).done(function(item){
            let items_obj = JSON.parse(item);
            items_obj["items"].forEach(i => {
                window.customCart.update(i);
            })
        });
    }

}
